'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TransitionablePortal = require('./TransitionablePortal');

var _TransitionablePortal2 = _interopRequireDefault(_TransitionablePortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TransitionablePortal2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/~/semantic-ui-react/dist/commonjs/addons/TransitionablePortal/index.js
 ** module id = 2835
 ** module chunks = 0
 **/